<template>
  <section>
    <div class="z-card border-0 integration-page">
      <h4>{{ $t('integration.api.create_group') }}</h4>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v1/database/group</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>
      <p>{{ $t('integration.api.example') }}</p>
      <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Group_ru"</span>
  }
</code>
      </pre>

      <p>{{ $t('integration.api.answer_example') }}</p>
      <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"id"</span>: <span class="hljs-number">15</span>
  }
</code>
      </pre>

      <h4>{{ $t('integration.api.get_all_groups') }}</h4>

      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v1/database/group</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> GET</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>
      <p>{{ $t('integration.api.answer_example') }}</p>
      <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"groups"</span>: [
          {
              <span class="hljs-attr">"id"</span>: <span class="hljs-number">1</span>,
              <span class="hljs-attr">"name"</span>: <span class="hljs-string">"FirstGroup"</span>,
              <span class="hljs-attr">"databases"</span>: <span class="hljs-number">0</span>
          },
          {
              <span class="hljs-attr">"id"</span>: <span class="hljs-number">2</span>,
              <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Group_ru"</span>,
              <span class="hljs-attr">"databases"</span>: <span class="hljs-number">0</span>
          }
      ]
  }
</code>
      </pre>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
